import { ErrorBlock } from '@/components/common/ErrorBlock'
import { NavSidebar } from '@/components/common/NavSidebar'
import { usePage } from '@/components/providers/PageProvider'
import { useScrollspyActiveSlug } from '@/components/providers/ScrollspyProvider'
import { isIconType } from '@/defs/icon'

import styles from './GuideSidebar.module.scss'

export const GuideSidebar = () => {
  const { page } = usePage()
  const activeSlug = useScrollspyActiveSlug()
  const article = page?.article
  const guide = article?.guide

  if (!article) return <ErrorBlock />

  const sections = guide?.map((g) => ({
    icon: isIconType(g.icon) ? g.icon : 'diamond',
    items: g.sections.map((s) => ({
      isSelected: s.slug === activeSlug,
      label: s.label,
      slug: s.slug,
    })),
    label: g.chapter,
  }))

  if (!sections?.length) return null

  return (
    <aside className={styles.container}>
      <NavSidebar sections={sections} />
    </aside>
  )
}
